import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const CampaignInfoBanner = (_param)=> {
    var { className , text , icon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "text",
        "icon"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('campaign-info-banner', className)
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: "campaign-info-banner__constrained-box"
    }, icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 18,
        height: 18
    }), /*#__PURE__*/ React.createElement("p", {
        className: "typography-text typography-text--caption campaign-info-banner__constrained-box__text"
    }, text)));
};
var CampaignInfoBanner$1 = CampaignInfoBanner;

export { CampaignInfoBanner$1 as default };
//# sourceMappingURL=CampaignInfoBanner.js.map
